import SVG from './image.svg';
import { face } from '~/notations';

export default {
  SVG,
  algorithm: [
    [
      face.m.one,
      face.u.one,
      face.m.one,
    ],
    face.u.one,
    [
      face.m.pri,
      face.u.pri,
      face.m.pri,
    ],
  ],
  name: '1B & 1T',
};
